var map = {
	"./1.png": 140,
	"./10.png": 141,
	"./100.jpg": 142,
	"./100.png": 143,
	"./11.png": 144,
	"./12.png": 145,
	"./2.png": 146,
	"./3.png": 147,
	"./4.png": 148,
	"./5.png": 149,
	"./6.png": 150,
	"./7.png": 151,
	"./8.png": 152,
	"./9.png": 153,
	"./DSF.svg": 154,
	"./b.png": 155,
	"./buld.jpg": 156,
	"./chalo.jpeg": 157,
	"./codeInLogo.png": 158,
	"./codeuino.jpg": 159,
	"./coursera_logo.png": 160,
	"./dataScience.svg": 63,
	"./deeplearning_ai_logo.png": 161,
	"./dev.svg": 64,
	"./development.svg": 162,
	"./googleAssistant.jpg": 163,
	"./google_logo.png": 164,
	"./greeting.svg": 61,
	"./hci.svg": 65,
	"./hrishi2.png": 165,
	"./ino.png": 166,
	"./intel_logo.jpg": 167,
	"./main_hero.png": 168,
	"./mathworks.png": 169,
	"./nit.jpeg": 170,
	"./nit.png": 171,
	"./profile.png": 60,
	"./quicko.jpg": 172,
	"./sal.png": 173,
	"./sbu.png": 174,
	"./stanford_logo.png": 175,
	"./vjt.png": 176,
	"./wipro-logo.png": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;